import * as JSONMapper from "json-mapper";
import {JSONMapped, jsonProperty} from "json-mapper-reflect";
import {Message} from "../common/message";
import {AvdbPricingProduct} from "./avdb-pricing-product";

export class AvdbPricingProductType extends JSONMapped() {
	@jsonProperty()
	id: number;

	@jsonProperty()
	name: string;

	@jsonProperty(JSONMapper.arrayOfClass(AvdbPricingProduct))
	products: Array<AvdbPricingProduct>;

	@jsonProperty(JSONMapper.arrayOfClass(Message))
	messages: Array<Message>;

	constructor(data?: Partial<AvdbPricingProductType>) {
		super();
		Object.assign(this, data);
	}

	get purchasableOnlyForAnnualSubscription(): boolean {
		return this.id === 12 // Map Enhancements
			|| this.id === 3 // Terrain
			|| this.id === 7; // Basemap
	}
}
